import React from "react";
import { IChainInfo } from "../../models/IChainInfo";
import { CabinetService } from "../../services/CabinetService";
import { INavService, NavService } from "../../services/NavService";
import { NullTranslator, Translator } from "../../services/TranslationService";
import { ICabinet } from "../../services/WebApiClient";


export interface CommonEditorProps {
    readonly navService: INavService;
    readonly cabinet: ICabinet;
    readonly cabinetService: CabinetService;
    readonly translator: Translator;
}

const chainInfo: IChainInfo = {
    chainId: -1,
    productLines: [],
    logoUrl: undefined,
    cssUrl: undefined,
    extraProducts: [],
    interiorMaterials: [],
};

const cabinet = CabinetService.createDefaultCabinet(chainInfo);

const cabinetService = new CabinetService(chainInfo,
    (t) => Promise.resolve(true),
    cabinet,
    c => true
);

const navService = new NavService(cabinetService);

const EditorContext = React.createContext<CommonEditorProps>({
    cabinet,
    cabinetService,
    navService,
    translator: NullTranslator
});


export { EditorContext };
